module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study-cs"
  }, [_c('navigation'), _vm._v(" "), _c('div', {
    ref: "scrollZone",
    staticClass: "case-study__scroll-zone"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    ref: "contentBackground",
    staticClass: "case-study-content-background"
  }, [_c('div', {
    ref: "content",
    staticClass: "case-study__content case-study__row"
  }, [_c('div', {
    ref: "infos",
    staticClass: "case-study__infos"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "case-study__champs"
  }, [_c('div', {
    staticClass: "case-study__photo-background-container"
  }, [_c('div', {
    staticClass: "case-study__photo-background"
  }), _vm._v(" "), _c('img', {
    ref: "logo",
    staticClass: "case-study__photo",
    attrs: {
      "src": "/static/assets/imgs/case-study/champs/champssports1.png"
    }
  })]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('case-study-video', {
    staticClass: "case-study__row case-study__video-row"
  }, [_c('source', {
    attrs: {
      "src": "/static/assets/videos/case-study/champs/ConversantChampsSpaceDemo.mp4",
      "type": "video/mp4"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "case-study__line case-study__row"
  }, [_vm._m(5), _vm._v(" "), _c('case-study-video', {
    staticClass: "case-study__half-block case-study__video-row"
  }, [_c('source', {
    attrs: {
      "src": "/static/assets/videos/case-study/champs/Champs_prototype_6.mp4",
      "type": "video/mp4"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "case-study__line case-study__row"
  }, [_c('div', {
    staticClass: "case-study__half-block"
  }, [_c('div', {
    staticClass: "case-study__screen-circle"
  }, [_c('img', {
    ref: "shoe",
    staticClass: "case-study__photo",
    attrs: {
      "src": "/static/assets/imgs/case-study/champs/77153_fr_sc7_rs.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _vm._m(6)])], 1)])]), _vm._v(" "), _vm._l((_vm.nextButtons), function(nextButton) {
    return _c('next-button', {
      key: nextButton.to,
      attrs: {
        "title": nextButton.title,
        "to": nextButton.to
      }
    })
  })], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__photo-background-container"
  }, [_c('div', {
    staticClass: "case-study__hero-title"
  }, [_vm._v("\n        Champs Sports\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__info"
  }, [_c('div', {
    staticClass: "case-study__info__title"
  }, [_vm._v("Context")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__info__text"
  }, [_vm._v("Conversant")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__info"
  }, [_c('div', {
    staticClass: "case-study__info__title"
  }, [_vm._v("Role")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__info__text"
  }, [_vm._v("Prototype Development")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__info"
  }, [_c('div', {
    staticClass: "case-study__info__title"
  }, [_vm._v("Period")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__info__text"
  }, [_vm._v("2016")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__row case-study__section"
  }, [_c('div', {
    staticClass: "case-study__section-title"
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__text-content"
  }, [_vm._v("\n              Champs Sports was one of the first clients for Conversant's SPACE (Special Project for the Advancement of Creative Elevation) initiative. SPACE is a week-long brainstorming program where a chosen core team is tasked to design a prototype unit that features functionality that has never been previously explored within Conversant. "), _c('br'), _c('br'), _vm._v("\n\n              The following is the resultant prototype, which focused on showcasing specific products in a unique way. This prototype received approval for a full production build and won increased adspend from the client.\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__half-block"
  }, [_c('div', {
    staticClass: "case-study__section-title"
  }, [_vm._v("Unit Features")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__text-content"
  }, [_c('ul', [_c('li', [_vm._v("• Dynamic elements")]), _vm._v(" "), _c('li', [_vm._v("• Accelerometer -based Parallax")]), _vm._v(" "), _c('li', [_vm._v("• GreenSock Animations")]), _vm._v(" "), _c('li', [_vm._v("• Hold to save a dynamic social image")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__half-block"
  }, [_c('div', {
    staticClass: "case-study__section-title"
  }, [_vm._v("Technology Stack")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__text-content"
  }, [_c('ul', [_c('li', [_vm._v("• JavaScript (Internal Framework)")]), _vm._v(" "), _c('li', [_vm._v("• GreenSock Animation Platform")]), _vm._v(" "), _c('li', [_vm._v("• Parallax.js")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a07cc85"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Champs.vue
// module id = 172
// module chunks = 1